import {  Hct, argbFromHex, hexFromArgb } from '@material/material-color-utilities'

import { useContext, useState } from 'react'
import _ from "lodash"

import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined'

import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'
import { PassImage } from '/components/editor/pass-image'

const HeroImage = () => {

  const { smartixPassType, variables, scannerData, device } = useContext(PassContext)
  const [imageHeight, setImageHeight] = useState(80)

  const waveDarken = Hct.fromInt(argbFromHex(variables.colours.background)).tone > 90

  const imageLoaded = e => {
    const img = e.target
    const displayedImageHeight = ((370 / img.width) * img.height) + 5
    setImageHeight(displayedImageHeight)
  }

  const type = smartixPassType === "managed_stamp" ? "stamp-images" : "image"

  let heroImage = getHeroImage()

  const stampBalanceRaw = _.get(variables, "stamp.stamps.balance", 0)
  const stampBalance = Math.max(0, Number.parseInt(stampBalanceRaw, 10) || 0)
  const stampHeroImage = _.get(scannerData, ["stamp_images", device, stampBalance])
  const fallbackStampHeroImage = _.get(scannerData, ["stamp_images", device, 0])
  if (smartixPassType === "managed_stamp") {
    heroImage = {
      ...heroImage,
      value: stampHeroImage || fallbackStampHeroImage || heroImage?.value
    }
  }

  const hasHero = heroImage?.value !== undefined && heroImage?.value !== '{{images.google.hero}}'

  return (
    <div className="image google-hero-image" style={{ position: "relative", minHeight: 80 }}>
      <PopupEditor title="Hero Image" path={heroImage.path} sources={heroImage} type={type}>
        {hasHero &&
          <>
            <div style={{ position: "absolute", height: imageHeight, width: "100%" }} className="editable" />
            <div className="heroWrapper">
              <PassImage src={heroImage.value} className="heroMirror heroMirrorTop" />
              <PassImage src={heroImage.value} className="heroImage" onLoad={e => imageLoaded(e)} />
              <PassImage src={heroImage.value} className="heroMirror heroMirrorBottom" />
            </div>
            <PhotoCameraOutlinedIcon className='editIcon' style={{ fontSize: 40, position: "absolute", bottom: 10, right: 10, zIndex: 1 }} />
          </>
        }
        {!hasHero &&
        <>
          <div className='-mb-10'><NoHeroSvg waveDarken={waveDarken}/></div>
          <PhotoCameraOutlinedIcon className='editIcon' style={{ fontSize: 40, position: "absolute", bottom: 50, right: 10, zIndex: 1 }} />
        </>
        }
      </PopupEditor>
    </div>
  )
}

export default HeroImage

const getHeroImage = () => {
  try {

    const { objectData, variables, passType } = useContext(PassContext)

    switch (passType) {
      case "generic":
        {
          return {
            template_source: "object",
            source: "object",
            path: "heroImage.sourceUri.uri",
            value: dataSelector({ objectData, variables, path: "heroImage.sourceUri.uri" })
          }
        }

      case "eventTicket":
      case "flight":
      case "transit":
      case "offer":
      case "loyalty":
      case "giftCard": {
        return {
          template_source: "object",
          source: "object",
          path: "heroImage.sourceUri.uri",
          value: dataSelector({ objectData, variables, path: "heroImage.sourceUri.uri" })

          // Only using object sp we can use our variables to update...

          //          template_source: "class",
          //          source: objectData.heroImage ? "object" : "class",
          //          path: "heroImage.sourceUri.uri",
          //          value: objectData.heroImage ? dataSelector({ objectData, variables, path: "heroImage.sourceUri.uri" }) : dataSelector({ objectData:classData, variables, path: "heroImage.sourceUri.uri" })
        }
      }
    }
  }
  catch (err) {
    console.error("Error destructuring hero path")
  }
}


const NoHeroSvg = ({waveDarken}) => <svg
  xmlns="http://www.w3.org/2000/svg"
  width="433"
  height="220"
  viewBox="0 0 433 220"
  preserveAspectRatio="none"
  style={{ display: "block", width: "100%", height: "auto" }}
>
  <defs>
    <linearGradient
      id="googleWaveGradient"
      x1="0"
      y1="0"
      x2="0"
      y2="1"
    >
      <stop offset="0%" stopColor={waveDarken ? "#000" :"#fff"} stopOpacity="0.005" />
      <stop offset="50%" stopColor={waveDarken ? "#000" :"#fff"}  stopOpacity="0.06" />
      <stop offset="100%" stopColor={waveDarken ? "#000" :"#fff"}  stopOpacity="0.15" />
    </linearGradient>
  </defs>

  <path
    d="
      M 0 0
      C 85 30, 165 102, 260 114
      C 330 122, 388 78, 433 45
      L 433 220
      L 0 220
      Z
    "
    fill="url(#googleWaveGradient)"
  />
</svg>
